module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-2-zoom.6d95095b.png";